export interface Chapter {
  id: string;
  title: string;
  views: number;
  updatedAt: string;
}

export const chaptersByComic: Record<string, Chapter[]> = {
  'tent-secret': [
    { id: '1', title: '第1话 意外的邀请', views: 8320000, updatedAt: '2026-08-14' },
    { id: '2', title: '第2话 同一顶帐篷', views: 7980000, updatedAt: '2026-08-13' },
    { id: '3', title: '第3话 心跳的距离', views: 7650000, updatedAt: '2026-08-12' },
    { id: '4', title: '第4话 篝火与夜话', views: 7420000, updatedAt: '2026-08-11' },
    { id: '5', title: '第5话 清晨的早安', views: 7180000, updatedAt: '2026-08-10' },
    { id: '6', title: '第6话 咖啡店的偶遇', views: 6950000, updatedAt: '2026-08-09' },
    { id: '7', title: '第7话 共享的伞', views: 6740000, updatedAt: '2026-08-08' },
    { id: '8', title: '第8话 加班夜', views: 6510000, updatedAt: '2026-08-07' },
    { id: '9', title: '第9话 秘密的纸条', views: 6320000, updatedAt: '2026-08-06' },
    { id: '10', title: '第10话 月光下的坦白', views: 6180000, updatedAt: '2026-08-05' },
    { id: '11', title: '第11话 心动预警', views: 5960000, updatedAt: '2026-08-04' },
    { id: '12', title: '第12话 周末的双人露营', views: 5830000, updatedAt: '2026-08-03' },
    { id: '13', title: '第13话 溪边的告白', views: 5690000, updatedAt: '2026-08-02' },
    { id: '14', title: '第14话 他的过去', views: 5540000, updatedAt: '2026-08-01' },
    { id: '15', title: '第15话 暴风雨夜', views: 5430000, updatedAt: '2026-07-31' },
    { id: '16', title: '第16话 温暖的怀抱', views: 5290000, updatedAt: '2026-07-30' },
    { id: '17', title: '第17话 误会与和解', views: 5160000, updatedAt: '2026-07-29' },
    { id: '18', title: '第18话 第一次约会', views: 5040000, updatedAt: '2026-07-28' },
    { id: '19', title: '第19话 见家长危机', views: 4910000, updatedAt: '2026-07-27' },
    { id: '20', title: '第20话 情敌出现', views: 4780000, updatedAt: '2026-07-26' },
    { id: '21', title: '第21话 心意的证明', views: 4650000, updatedAt: '2026-07-25' },
    { id: '22', title: '第22话 星空下的承诺', views: 4520000, updatedAt: '2026-07-24' },
    { id: '23', title: '第23话 短暂的分别', views: 4390000, updatedAt: '2026-07-23' },
    { id: '24', title: '第24话 思念成疾', views: 4260000, updatedAt: '2026-07-22' },
    { id: '25', title: '第25话 重逢的拥抱', views: 4130000, updatedAt: '2026-07-21' },
    { id: '26', title: '第26话 坦白心迹', views: 3980000, updatedAt: '2026-07-20' },
    { id: '27', title: '第27话 甜蜜同居', views: 3850000, updatedAt: '2026-07-19' },
    { id: '28', title: '第28话 求婚计划', views: 3720000, updatedAt: '2026-07-18' },
    { id: '29', title: '第29话 携手余生', views: 3580000, updatedAt: '2026-07-17' },
    { id: '30', title: '第30话 新的开始', views: 3460000, updatedAt: '2026-07-16' },
  ],
  'first-love': [
    { id: '1', title: '第1话 转学生的开场', views: 5120000, updatedAt: '2026-08-12' },
    { id: '2', title: '第2话 被撞翻的蛋糕', views: 4980000, updatedAt: '2026-08-10' },
    { id: '3', title: '第3话 临时试吃员', views: 4860000, updatedAt: '2026-08-08' },
    { id: '4', title: '第4话 芒果布丁的约定', views: 4720000, updatedAt: '2026-08-06' },
    { id: '5', title: '第5话 运动会风波', views: 4580000, updatedAt: '2026-08-04' },
    { id: '6', title: '第6话 社团对抗赛', views: 4410000, updatedAt: '2026-08-02' },
    { id: '7', title: '第7话 深夜试吃', views: 4270000, updatedAt: '2026-07-31' },
    { id: '8', title: '第8话 告白倒计时', views: 4120000, updatedAt: '2026-07-29' },
    { id: '9', title: '第9话 樱花树下的答案', views: 3960000, updatedAt: '2026-07-27' },
    { id: '10', title: '第10话 甜蜜的终点', views: 3810000, updatedAt: '2026-07-25' },
  ],
  'urban-contract': [
    { id: '1', title: '第1话 一纸契约', views: 4650000, updatedAt: '2026-08-11' },
    { id: '2', title: '第2话 假扮恋人', views: 4520000, updatedAt: '2026-08-09' },
    { id: '3', title: '第3话 家族晚宴', views: 4380000, updatedAt: '2026-08-07' },
    { id: '4', title: '第4话 初见真心', views: 4210000, updatedAt: '2026-08-05' },
    { id: '5', title: '第5话 商战暗涌', views: 4050000, updatedAt: '2026-08-03' },
    { id: '6', title: '第6话 雨夜的拥抱', views: 3920000, updatedAt: '2026-08-01' },
    { id: '7', title: '第7话 合同的裂痕', views: 3760000, updatedAt: '2026-07-30' },
    { id: '8', title: '第8话 假戏真做', views: 3620000, updatedAt: '2026-07-28' },
    { id: '9', title: '第9话 真相与抉择', views: 3480000, updatedAt: '2026-07-26' },
    { id: '10', title: '第10话 续约终身', views: 3320000, updatedAt: '2026-07-24' },
  ],
  'moonlight-knights': [
    { id: '1', title: '第1话 见习骑士', views: 5780000, updatedAt: '2026-08-13' },
    { id: '2', title: '第2话 月圆之夜', views: 5610000, updatedAt: '2026-08-11' },
    { id: '3', title: '第3话 月光之力', views: 5470000, updatedAt: '2026-08-09' },
    { id: '4', title: '第4话 骑士团的试炼', views: 5320000, updatedAt: '2026-08-07' },
    { id: '5', title: '第5话 暗影来袭', views: 5180000, updatedAt: '2026-08-05' },
    { id: '6', title: '第6话 千年的宿命', views: 5030000, updatedAt: '2026-08-03' },
    { id: '7', title: '第7话 银月圣剑', views: 4870000, updatedAt: '2026-08-01' },
    { id: '8', title: '第8话 龙脊之战', views: 4720000, updatedAt: '2026-07-30' },
    { id: '9', title: '第9话 王城之谜', views: 4560000, updatedAt: '2026-07-28' },
    { id: '10', title: '第10话 黎明前的夜', views: 4410000, updatedAt: '2026-07-26' },
  ],
  'super-power-class': [
    { id: '1', title: '第1话 特殊班级', views: 4120000, updatedAt: '2026-08-10' },
    { id: '2', title: '第2话 觉醒时刻', views: 3980000, updatedAt: '2026-08-08' },
    { id: '3', title: '第3话 超能训练', views: 3850000, updatedAt: '2026-08-06' },
    { id: '4', title: '第4话 校园危机', views: 3710000, updatedAt: '2026-08-04' },
    { id: '5', title: '第5话 社团大战', views: 3560000, updatedAt: '2026-08-02' },
    { id: '6', title: '第6话 隐世强者', views: 3420000, updatedAt: '2026-07-31' },
    { id: '7', title: '第7话 期末考试', views: 3280000, updatedAt: '2026-07-29' },
    { id: '8', title: '第8话 天台对决', views: 3140000, updatedAt: '2026-07-27' },
    { id: '9', title: '第9话 并肩作战', views: 2990000, updatedAt: '2026-07-25' },
    { id: '10', title: '第10话 英雄的日常', views: 2850000, updatedAt: '2026-07-23' },
  ],
  'fog-detective': [
    { id: '1', title: '第1话 离职的警队传奇', views: 4920000, updatedAt: '2026-08-12' },
    { id: '2', title: '第2话 第一桩委托', views: 4780000, updatedAt: '2026-08-10' },
    { id: '3', title: '第3话 镜子里的影子', views: 4630000, updatedAt: '2026-08-08' },
    { id: '4', title: '第4话 消失的目击者', views: 4480000, updatedAt: '2026-08-06' },
    { id: '5', title: '第5话 雾中的线索', views: 4320000, updatedAt: '2026-08-04' },
    { id: '6', title: '第6话 幽灵列车', views: 4180000, updatedAt: '2026-08-02' },
    { id: '7', title: '第7话 尘封的档案', views: 4030000, updatedAt: '2026-07-31' },
    { id: '8', title: '第8话 真相的影子', views: 3880000, updatedAt: '2026-07-29' },
    { id: '9', title: '第9话 惊天秘密', views: 3740000, updatedAt: '2026-07-27' },
    { id: '10', title: '第10话 迷雾散去', views: 3590000, updatedAt: '2026-07-25' },
  ],
  'reborn-tycoon': [
    { id: '1', title: '第1话 重回二十岁', views: 3980000, updatedAt: '2026-08-11' },
    { id: '2', title: '第2话 第一桶金', views: 3840000, updatedAt: '2026-08-09' },
    { id: '3', title: '第3话 商界初试', views: 3700000, updatedAt: '2026-08-07' },
    { id: '4', title: '第4话 釜山风云', views: 3550000, updatedAt: '2026-08-05' },
    { id: '5', title: '第5话 家族博弈', views: 3410000, updatedAt: '2026-08-03' },
    { id: '6', title: '第6话 逆风翻盘', views: 3260000, updatedAt: '2026-08-01' },
    { id: '7', title: '第7话 商界巨鳄', views: 3120000, updatedAt: '2026-07-30' },
    { id: '8', title: '第8话 复仇之路', views: 2980000, updatedAt: '2026-07-28' },
    { id: '9', title: '第9话 巅峰对决', views: 2840000, updatedAt: '2026-07-26' },
    { id: '10', title: '第10话 王者归来', views: 2690000, updatedAt: '2026-07-24' },
  ],
  'cloud-lovers': [
    { id: '1', title: '第1话 坠落人间', views: 4280000, updatedAt: '2026-08-13' },
    { id: '2', title: '第2话 收留的天气神', views: 4140000, updatedAt: '2026-08-11' },
    { id: '3', title: '第3话 晴天咒语', views: 4000000, updatedAt: '2026-08-09' },
    { id: '4', title: '第4话 云端之约', views: 3850000, updatedAt: '2026-08-07' },
    { id: '5', title: '第5话 彩虹桥', views: 3710000, updatedAt: '2026-08-05' },
    { id: '6', title: '第6话 回到云端', views: 3560000, updatedAt: '2026-08-03' },
    { id: '7', title: '第7话 跨越世界', views: 3420000, updatedAt: '2026-08-01' },
    { id: '8', title: '第8话 永恒的晴天', views: 3270000, updatedAt: '2026-07-30' },
    { id: '9', title: '第9话 人间值得', views: 3130000, updatedAt: '2026-07-28' },
    { id: '10', title: '第10话 云淡风轻', views: 2980000, updatedAt: '2026-07-26' },
  ],
  'sword-magic': [
    { id: '1', title: '第1话 古龙封印', views: 3620000, updatedAt: '2026-08-10' },
    { id: '2', title: '第2话 会说话的小龙', views: 3480000, updatedAt: '2026-08-08' },
    { id: '3', title: '第3话 魔法学院的插班生', views: 3340000, updatedAt: '2026-08-06' },
    { id: '4', title: '第4话 圣剑传说', views: 3210000, updatedAt: '2026-08-04' },
    { id: '5', title: '第5话 迷失森林', views: 3070000, updatedAt: '2026-08-02' },
    { id: '6', title: '第6话 龙之试炼', views: 2930000, updatedAt: '2026-07-31' },
    { id: '7', title: '第7话 圣剑觉醒', views: 2790000, updatedAt: '2026-07-29' },
    { id: '8', title: '第8话 魔王降临', views: 2650000, updatedAt: '2026-07-27' },
    { id: '9', title: '第9话 伙伴的力量', views: 2510000, updatedAt: '2026-07-25' },
    { id: '10', title: '第10话 新的传说', views: 2360000, updatedAt: '2026-07-23' },
  ],
  'midnight-diner': [
    { id: '1', title: '第1话 深夜的灯光', views: 4820000, updatedAt: '2026-08-12' },
    { id: '2', title: '第2话 一碗热汤', views: 4690000, updatedAt: '2026-08-10' },
    { id: '3', title: '第3话 加班族的夜宵', views: 4550000, updatedAt: '2026-08-08' },
    { id: '4', title: '第4话 老朋友的秘密', views: 4410000, updatedAt: '2026-08-06' },
    { id: '5', title: '第5话 母亲的饺子', views: 4280000, updatedAt: '2026-08-04' },
    { id: '6', title: '第6话 初雪与辣汤', views: 4140000, updatedAt: '2026-08-02' },
    { id: '7', title: '第7话 失恋的烤串', views: 4010000, updatedAt: '2026-07-31' },
    { id: '8', title: '第8话 家的味道', views: 3870000, updatedAt: '2026-07-29' },
    { id: '9', title: '第9话 雨夜的约定', views: 3720000, updatedAt: '2026-07-27' },
    { id: '10', title: '第10话 暖胃更暖心', views: 3580000, updatedAt: '2026-07-25' },
  ],
  'passion-basketball': [
    { id: '1', title: '第1话 一米七的梦想', views: 3520000, updatedAt: '2026-08-11' },
    { id: '2', title: '第2话 入社考验', views: 3380000, updatedAt: '2026-08-09' },
    { id: '3', title: '第3话 地狱训练', views: 3240000, updatedAt: '2026-08-07' },
    { id: '4', title: '第4话 首秀之战', views: 3100000, updatedAt: '2026-08-05' },
    { id: '5', title: '第5话 天才对手', views: 2960000, updatedAt: '2026-08-03' },
    { id: '6', title: '第6话 伤病危机', views: 2820000, updatedAt: '2026-08-01' },
    { id: '7', title: '第7话 重新起跳', views: 2680000, updatedAt: '2026-07-30' },
    { id: '8', title: '第8话 全国大赛', views: 2540000, updatedAt: '2026-07-28' },
    { id: '9', title: '第9话 决胜时刻', views: 2400000, updatedAt: '2026-07-26' },
    { id: '10', title: '第10话 热爱永不落幕', views: 2250000, updatedAt: '2026-07-24' },
  ],
  'fox-contract': [
    { id: '1', title: '第1话 深夜的妖狐', views: 4550000, updatedAt: '2026-08-13' },
    { id: '2', title: '第2话 血契之约', views: 4410000, updatedAt: '2026-08-11' },
    { id: '3', title: '第3话 驱魔世家的秘密', views: 4270000, updatedAt: '2026-08-09' },
    { id: '4', title: '第4话 狐火之夜', views: 4130000, updatedAt: '2026-08-07' },
    { id: '5', title: '第5话 人妖殊途', views: 3990000, updatedAt: '2026-08-05' },
    { id: '6', title: '第6话 千年之约', views: 3850000, updatedAt: '2026-08-03' },
    { id: '7', title: '第7话 心魔试炼', views: 3710000, updatedAt: '2026-08-01' },
    { id: '8', title: '第8话 情深缘浅', views: 3570000, updatedAt: '2026-07-30' },
    { id: '9', title: '第9话 打破命运', views: 3430000, updatedAt: '2026-07-28' },
    { id: '10', title: '第10话 两心相许', views: 3280000, updatedAt: '2026-07-26' },
  ],
  'gentle-zone': [
    { id: '1', title: '第1话 命运的偶遇', views: 6180000, updatedAt: '2026-08-14' },
    { id: '2', title: '第2话 旧书店重逢', views: 6020000, updatedAt: '2026-08-12' },
    { id: '3', title: '第3话 图纸与画笔', views: 5870000, updatedAt: '2026-08-10' },
    { id: '4', title: '第4话 温柔的距离', views: 5730000, updatedAt: '2026-08-08' },
    { id: '5', title: '第5话 尘封的往事', views: 5580000, updatedAt: '2026-08-06' },
    { id: '6', title: '第6话 并肩的夜晚', views: 5430000, updatedAt: '2026-08-04' },
    { id: '7', title: '第7话 禁区边缘', views: 5280000, updatedAt: '2026-08-02' },
    { id: '8', title: '第8话 温柔的答案', views: 5140000, updatedAt: '2026-07-31' },
    { id: '9', title: '第9话 交付真心', views: 4990000, updatedAt: '2026-07-29' },
    { id: '10', title: '第10话 相守之约', views: 4840000, updatedAt: '2026-07-27' },
  ],
  'time-bureau': [
    { id: '1', title: '第1话 新人特工', views: 4220000, updatedAt: '2026-08-12' },
    { id: '2', title: '第2话 第一桩案件', views: 4080000, updatedAt: '2026-08-10' },
    { id: '3', title: '第3话 时间裂缝', views: 3940000, updatedAt: '2026-08-08' },
    { id: '4', title: '第4话 记忆错乱', views: 3810000, updatedAt: '2026-08-06' },
    { id: '5', title: '第5话 时间悖论', views: 3670000, updatedAt: '2026-08-04' },
    { id: '6', title: '第6话 过去的自己', views: 3520000, updatedAt: '2026-08-02' },
    { id: '7', title: '第7话 记忆骗局', views: 3380000, updatedAt: '2026-07-31' },
    { id: '8', title: '第8话 时光倒流', views: 3240000, updatedAt: '2026-07-29' },
    { id: '9', title: '第9话 真相大白', views: 3090000, updatedAt: '2026-07-27' },
    { id: '10', title: '第10话 重启时间线', views: 2950000, updatedAt: '2026-07-25' },
  ],
};

export function getChapters(comicId: string): Chapter[] {
  return chaptersByComic[comicId] ?? [];
}